// deps
import React, { ReactElement, useMemo } from "react";

// interface
import { ICodPaymentGroup } from "@payment-ui/interfaces/Cod";

// components
import PaymentGroupContainer from "../components/Container";
import PaymentGroupTitle from "../components/Title";
import Cod from "@payment-ui/components/payment-method/cod";

//helpers
import { isEmpty } from "@swiggy-private/payment-core";
import {
    isPaymentMethodSelected,
    getPaymentMethods,
    generatePaymentMethodId,
    getPaymentGroupDisplayName,
    isPaymentGroupEnabled,
    getPaymentGroupDisableMessage,
    getPaymentGroupIconUrl,
} from "@payment-ui/helpers/Payment";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

export default function CODPaymentGroup(props: ICodPaymentGroup): ReactElement | null {
    const { isFrictionPage, paymentAmount } = props;
    const paymentMethods = useMemo(() => getPaymentMethods(props), [props]);
    const isGroupEnabled = useMemo(() => isPaymentGroupEnabled(props.paymentData), [props.paymentData]);

    if (isEmpty(paymentMethods)) {
        return null;
    }

    return (
        <PaymentGroupContainer isFrictionPage={isFrictionPage}>
            {!props.hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(props.paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(props.paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.COD}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map(paymentMethod => {
                    const id = generatePaymentMethodId(paymentMethod);
                    return (
                        <Cod
                            key={paymentMethod.displayName}
                            id={id}
                            methodData={paymentMethod}
                            paymentAmount={paymentAmount}
                            paymentActions={props.paymentActions}
                            isPaymentGroupEnabled={isGroupEnabled}
                            selected={isPaymentMethodSelected(props.selectedPaymentId, id)}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}
